import React from 'react';
import { Routes, Route } from 'react-router-dom';
import EmpresaPontoApp from './EmpresaPontoApp';

const EmpresaPontoLayout = () => {
  return (
    <Routes>
      <Route index element={<EmpresaPontoApp />} />
    </Routes>
  );
};

export default EmpresaPontoLayout;
